import http from './http'
import qs from 'qs'

function licenseRequests (id, licenseNumber) {
  return http({
    method: 'POST',
    url: '/divisions/' + id + '/licenseRequests',
    data: qs.stringify({
      licenseNumber
    })
  })
}

function cancelLicenseRequests (id) {
  return http({
    method: 'DELETE',
    url: '/divisions/' + id + '/licenseRequests',
  })
}

function getDivisions () {
  return http({
    method: 'GET',
    url: '/divisions'
  })
}

function getDivisionById (id) {
  return http({
    method: 'GET',
    url: '/divisions/' + id
  })
}

function deleteDivisionById (id) {
  return http({
    method: 'DELETE',
    url: '/divisions/' + id
  })
}

function updateDivisionById (id, data) {
  return http({
    method: 'PUT',
    url: '/divisions/' + id,
    data
  })
}
function manageDivisionLicensesById (id, data) {
  return http({
    method: 'POST',
    url: '/divisions/' + id + '/resolveLicenseRequest',
    data: qs.stringify(data)
  })
}

function createDivision (data) {
  return http({
    method: 'POST',
    url: '/divisions',
    data
  })
}

export {
  licenseRequests,
  cancelLicenseRequests,

  getDivisions,
  getDivisionById,
  deleteDivisionById,
  updateDivisionById,
  manageDivisionLicensesById,
  createDivision
}



// WEBPACK FOOTER //
// ./src/services/api/division.js